export default __webpack_public_path__ + "static/media/min- (3).5499dbe7.png";